import softDelete from '../../../abstract/actions/soft-delete';
import edit from './edit';
import impersonate from './impersonate';

export default {
  impersonate,
  edit,
  softDelete,
};
